/**
 * Browser Preview SVG Component
 * 
 * Displays a realistic browser window mockup for the accessibility toolbar preview
 */
export const BrowserPreview = () => {
  return (
    <svg
      width="381"
      height="220"
      viewBox="0 0 381 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_537_603)">
        <rect
          x="1"
          y="0.5"
          width="379.5"
          height="219"
          rx="5.5"
          fill="white"
          stroke="#1869E3"
        />
        <g clipPath="url(#clip1_537_603)">
          <path
            d="M13.6778 0H368.323C374.767 0 380 4.78413 380 10.6753V189.411C380 195.302 374.767 200.086 368.323 200.086H13.3442C6.5311 200.086 1 195.03 1 188.801V11.5904C1 5.19364 6.68092 0 13.6778 0Z"
            fill="#7C95A5"
          />
          <path
            d="M1.33363 0H380V220.078H1V0.335485C1 0.150658 1.14982 0 1.33363 0Z"
            fill="#1578F7"
          />
          <path d="M380 35.8364H1V219H380V35.8364Z" fill="white" />
          <path
            d="M103.254 22.8129C100.947 22.8129 99.077 20.9321 99.0801 18.6116C99.0847 14.8126 99.0863 9.81289 99.0863 9.81289C99.0863 6.24681 96.2103 3.3548 92.664 3.3548H33.4452C29.8989 3.3548 27.0229 6.24681 27.0229 9.81289C27.0229 9.81289 27.0244 13.8605 27.0275 17.439C27.0306 20.4071 24.6381 22.8129 21.688 22.8129H1V47.6389H380V22.8129H103.254Z"
            fill="white"
          />
          <path
            d="M17.4589 35.1701C17.4527 35.4667 17.2087 35.7044 16.9137 35.6981L5.97351 35.4916C5.6785 35.4854 5.44218 35.24 5.44836 34.9433C5.45454 34.6466 5.69858 34.409 5.99359 34.4152L16.9338 34.6218C17.2288 34.628 17.4651 34.8734 17.4589 35.1701Z"
            fill="#D7D9E5"
          />
          <path
            d="M5.53202 34.8202L5.65395 34.684C5.78001 34.5432 5.99493 34.5329 6.13384 34.6587L10.106 38.2538C10.246 38.3806 10.2563 38.5967 10.1312 38.7364L10.0093 38.8726C9.88322 39.0135 9.6683 39.0237 9.52939 38.898L5.55725 35.3028C5.41719 35.176 5.40699 34.9599 5.53202 34.8202Z"
            fill="#D7D9E5"
          />
          <path
            d="M10.2748 31.3311L10.1581 31.1904C10.0379 31.0455 9.8236 31.026 9.67948 31.1468L5.5754 34.5889C5.43128 34.7098 5.41189 34.9253 5.5321 35.0702L5.64884 35.211C5.76904 35.3559 5.98332 35.3754 6.12744 35.2545L10.2315 31.8124C10.3756 31.6915 10.395 31.4761 10.2748 31.3311Z"
            fill="#D7D9E5"
          />
          <path
            d="M23.465 35.1701C23.4711 35.4668 23.7152 35.7044 24.0102 35.6982L34.9504 35.4916C35.2454 35.4854 35.4817 35.24 35.4755 34.9434C35.4693 34.6467 35.2253 34.4091 34.9303 34.4153L23.9901 34.6219C23.6951 34.6281 23.4588 34.8735 23.465 35.1701Z"
            fill="#D7D9E5"
          />
          <path
            d="M30.9133 38.8701L30.7914 38.7339C30.6654 38.593 30.6778 38.377 30.8167 38.2513L34.7895 34.6568C34.9296 34.5301 35.1444 34.5426 35.2694 34.6823L35.3913 34.8185C35.5174 34.9594 35.5049 35.1754 35.366 35.3011L31.3932 38.8956C31.2531 39.0223 31.0383 39.0098 30.9133 38.8701Z"
            fill="#D7D9E5"
          />
          <path
            d="M35.2808 35.2117L35.3976 35.071C35.5178 34.9261 35.4984 34.7106 35.3543 34.5897L31.2502 31.1476C31.1061 31.0268 30.8918 31.0463 30.7716 31.1912L30.6549 31.3319C30.5347 31.4768 30.554 31.6923 30.6982 31.8132L34.8022 35.2553C34.9464 35.3762 35.1606 35.3567 35.2808 35.2117Z"
            fill="#D7D9E5"
          />
          <path
            d="M351.38 25.9675H56.1515C51.1765 25.9675 47.1436 30.023 47.1436 35.0256C47.1436 40.0283 51.1765 44.0837 56.1515 44.0837H351.38C356.355 44.0837 360.388 40.0283 360.388 35.0256C360.388 30.023 356.355 25.9675 351.38 25.9675Z"
            fill="#EFF2FF"
          />
          <path
            d="M370.825 32.9831H367.21C366.501 32.9831 365.927 32.4053 365.927 31.6924C365.927 30.9795 366.501 30.4017 367.21 30.4017H370.825C371.534 30.4017 372.108 30.9795 372.108 31.6924C372.108 32.4053 371.534 32.9831 370.825 32.9831Z"
            fill="#CFD3E8"
          />
          <path
            d="M370.825 36.3162H367.21C366.501 36.3162 365.927 35.7385 365.927 35.0255C365.927 34.3126 366.501 33.7349 367.21 33.7349H370.825C371.534 33.7349 372.108 34.3126 372.108 35.0255C372.108 35.7385 371.534 36.3162 370.825 36.3162Z"
            fill="#CFD3E8"
          />
          <path
            d="M370.825 39.6477H367.21C366.501 39.6477 365.927 39.0699 365.927 38.357C365.927 37.6441 366.501 37.0663 367.21 37.0663H370.825C371.534 37.0663 372.108 37.6441 372.108 38.357C372.108 39.0699 371.534 39.6477 370.825 39.6477Z"
            fill="#CFD3E8"
          />
          <path
            d="M59.7008 30.9097C58.3493 29.5507 56.1483 29.5507 54.7968 30.9097C53.4453 32.2687 53.4453 34.482 54.7968 35.841C55.9923 37.0432 57.8489 37.1814 59.1988 36.2588L62.8888 39.9694C63.1421 40.2241 63.553 40.2241 63.8063 39.9694C64.0596 39.7147 64.0596 39.3015 63.8063 39.0468L60.1163 35.3363C61.0338 33.9803 60.8963 32.1119 59.7008 30.9097ZM58.7834 34.92C57.9369 35.7711 56.5607 35.7711 55.7143 34.92C54.8679 34.0689 54.8679 32.685 55.7143 31.8339C56.5607 30.9827 57.9369 30.9827 58.7834 31.8339C59.6298 32.685 59.6298 34.0689 58.7834 34.92Z"
            fill="#CFD3E8"
          />
          <path
            opacity="0.2"
            d="M341.169 77.4766H215.795C214.907 77.4766 214.188 78.8204 214.188 80.478V196.866C214.188 198.523 214.907 199.867 215.795 199.867H341.169C342.057 199.867 342.777 198.523 342.777 196.866V80.478C342.777 78.8204 342.057 77.4766 341.169 77.4766Z"
            fill="#F2F3F8"
          />
          <g clipPath="url(#clip2_537_603)">
            <rect
              width="128.227"
              height="122.886"
              transform="translate(214.188 77.8303)"
              fill="#F2F3F8"
            />
            <path
              opacity="0.2"
              d="M328.978 140.274C361.777 140.274 377.756 166.081 409.715 200.717C383.644 200.717 272.029 200.717 239.829 200.717C267.583 172.193 296.177 140.274 328.978 140.274Z"
              fill="#D3DAFB"
            />
            <path
              opacity="0.2"
              d="M219.803 130.659C254.862 130.659 277.545 164.064 308.89 200.717C267.763 200.717 168.165 200.717 130.717 200.717C160.994 164.064 184.745 130.659 219.803 130.659Z"
              fill="#CDD9FF"
            />
            <path
              opacity="0.5"
              d="M278.501 130.891C285.367 130.891 290.932 125.326 290.932 118.46C290.932 111.595 285.367 106.03 278.501 106.03C271.636 106.03 266.07 111.595 266.07 118.46C266.07 125.326 271.636 130.891 278.501 130.891Z"
              fill="#D3DAFB"
            />
          </g>
          <path
            opacity="0.5"
            d="M190.253 125.759H35.0857C33.7035 125.759 32.583 126.764 32.583 128.005C32.583 129.245 33.7035 130.25 35.0857 130.25H190.253C191.635 130.25 192.756 129.245 192.756 128.005C192.756 126.764 191.635 125.759 190.253 125.759Z"
            fill="#E3E8FF"
          />
          <path
            d="M75.1954 160.567H35.0896C33.7052 160.567 32.583 161.657 32.583 163V172.732C32.583 174.075 33.7052 175.164 35.0896 175.164H75.1954C76.5798 175.164 77.7021 174.075 77.7021 172.732V163C77.7021 161.657 76.5798 160.567 75.1954 160.567Z"
            fill="#E3E8FF"
          />
          <path
            d="M114.693 105.548H35.0712C33.697 105.548 32.583 106.679 32.583 108.074V113.127C32.583 114.522 33.697 115.653 35.0712 115.653H114.693C116.067 115.653 117.181 114.522 117.181 113.127V108.074C117.181 106.679 116.067 105.548 114.693 105.548Z"
            fill="#E3E8FF"
          />
          <circle cx="362.516" cy="12.9717" r="3.94792" fill="white" />
          <circle cx="350.109" cy="12.9717" r="3.94792" fill="white" />
          <circle cx="337.701" cy="12.9717" r="3.94792" fill="white" />
          <line
            x1="1"
            y1="46.811"
            x2="380"
            y2="46.811"
            stroke="#F2F3F8"
            strokeWidth="1.12798"
          />
          <rect
            x="34.8389"
            y="11.2797"
            width="45.119"
            height="3.38393"
            fill="#EBEEF9"
          />
        </g>
        <rect
          x="1.25"
          y="0.25"
          width="378.5"
          height="218.5"
          rx="4.75"
          stroke="#1578F7"
          strokeWidth="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_537_603">
          <rect width="380.5" height="220" fill="white" transform="translate(0.5)" />
        </clipPath>
        <clipPath id="clip1_537_603">
          <rect x="1" width="379" height="219" rx="5" fill="white" />
        </clipPath>
        <clipPath id="clip2_537_603">
          <rect
            width="128.227"
            height="122.886"
            fill="white"
            transform="translate(214.188 77.8303)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

